import React from 'react'
import type { SourceMetricsWithTrendsData } from '../../../../../types/dataQuality'
import MetricCard from './MetricCard'

interface FileMetricsGridProps {
  metricsData?: SourceMetricsWithTrendsData
}

const FileMetricsGrid: React.FC<FileMetricsGridProps> = ({ metricsData }) => {
  const getMetricValue = (value?: number, defaultValue: number = 0): number => {
    return value ?? defaultValue
  }

  return (
    <div className="metric-cards-grid">
      <MetricCard
        label="Completeness (%)"
        value={getMetricValue(metricsData?.metrics?.completeness_score?.current_value, 99.2)}
        showDecimal={true}
      />
      <MetricCard
        label="Timeliness (%)"
        value={getMetricValue(metricsData?.summary?.freshness_percentage, 99.2)}
        showDecimal={true}
      />
      <MetricCard
        label="Quality (%)"
        value={getMetricValue(metricsData?.metrics?.quality_rules_pass_rate?.current_value, 98.8)}
        showDecimal={true}
      />
      <MetricCard
        label="Schema (%)"
        value={getMetricValue(metricsData?.schema_drift?.stability_score, 100.0)}
        showDecimal={true}
      />
      <MetricCard
        label="Duplicate (%)"
        value={getMetricValue(metricsData?.summary?.duplicate_percentage, 0)}
        showDecimal={false}
        inverse={true}
      />
     
    </div>
  )
}

export default FileMetricsGrid
